<template>
  <el-dialog
    title="系统参数编辑窗口"
    :visible.sync="visible"
    @close="close">

    <el-form :model="SyspaEditForm" label-position="right">
      <el-form-item label="参数名称">
        <el-input v-model="SyspaEditForm.parname" autocomplete="off" :disabled="true"></el-input>
      </el-form-item>        
      <el-form-item label="参数值">
        <el-input v-model="SyspaEditForm.parameter" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="单位">
        <el-input v-model="SyspaEditForm.unit" autocomplete="off"></el-input>
      </el-form-item>          
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取消</el-button>
      <el-button type="primary" @click="ok">确定</el-button>
    </div>

  </el-dialog>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    dialogData: {
      type: Object,
      default(){
        return null
      },
    },
  },
  data() {
    return {
      SyspaEditForm: {
        id:'',
        parname: '',
        parameter: '',
        unit: '',
      },
      visible: false,
    };
  },
  watch: {
    dialogVisible(val) {
      // console.log("dialogVisible传入数据在这里",val);
      this.visible = val;
    },
    dialogData(data){
      // console.log("coreedit传入数据在这里",data);
      this.SyspaEditForm.parname = data.parname;
      this.SyspaEditForm.parameter = data.parameter;
      this.SyspaEditForm.unit = data.unit;
      this.SyspaEditForm.id = data.id;
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    ok() {
      this.$emit('ok', {
        ...this.SyspaEditForm,
      });
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
